<template>
    <div class="as-master-page">
        <PageTitle title="As a Master" />
        <AsAMasterPageMenu :your_mastered_responsibilities_count="totalRecords" />
        <div class="as-master-page-content">
            <div class="as-master-page-banner" v-if="responsibilitiesWithNoCheckpoints > 0">
                <AsMasterNoCheckpointBanner :responsibilityCount="responsibilitiesWithNoCheckpoints" />
            </div>
            <div class="as-master-page-table">
                <MasteredResponsibilityTable 
                    :dataStream="masteredResponsibilities" 
                    :totalRecords="totalRecords"
                    :currentPage="currentPage"
                    :pageSize="pageSize"
                    @search="handleSearch"
                    @filter="handleFilter"
                    @pageChange="handlePageChange"
                    @pageSizeChange="handlePageSizeChange"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from "vue";
    import PageTitle from "@components/common/PageTitle.vue";
    import AsAMasterPageMenu from "@components/AsAMasterPageMenu/AsAMasterPageMenu.vue";
    import AsMasterNoCheckpointBanner from "@components/AsMaster/AsMasterNoCheckpointBanner/AsMasterNoCheckpointBanner.vue";
    import MasteredResponsibilityTable from "@components/MasteredResponsibilityTable/MasteredResponsibilityTable.vue";

    const props = defineProps({
        dataStream: {
            type: Array,
            default: () => [],
        },
        totalRecords: {
            type: Number,
            default: 0,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
    });

    const emit = defineEmits(['search', 'filter', 'pageChange', 'pageSizeChange']);

    const masteredResponsibilities = ref(props.dataStream);

    watch(() => props.dataStream, (newVal) => {
        masteredResponsibilities.value = newVal;
    });

    // Calculate responsibilities with no active checkpoints
    const responsibilitiesWithNoCheckpoints = computed(() => {
        return masteredResponsibilities.value.filter(
            (resp) => (resp.active_checkpoints_count || 0) === 0
        ).length;
    });

    const handleSearch = (query) => {
        emit('search', query);
    };

    const handleFilter = (filters) => {
        emit('filter', filters);
    };

    const handlePageChange = (page) => {
        emit('pageChange', page);
    };

    const handlePageSizeChange = (size) => {
        emit('pageSizeChange', size);
    };
</script>

<style scoped>
.as-master-page {
    width: 100%;
    background-color: #FFFFFF;
}
.as-master-page-content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-radius: 8px;
    border: 1px solid #EAECF0;
    background: #FFFFFF;
    box-shadow: 0 1px 3px 0 rgba(16, 24, 40, 0.10), 0 1px 2px 0 rgba(16, 24, 40, 0.06);
}
.as-master-page-banner {
    padding: 20px 16px 0px 16px;
}
.as-master-page-table {
    margin-top: 15px;
}

::v-deep(.menu-btn) {
    padding: 0px !important;
}

::v-deep(.input-search) {
    right: 16px !important;
}
:deep(.as-a-master-page-menu .row) {
    margin-top: 0px !important;
}
</style>